import { TextField } from "@mui/material";
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import { useSnackbar } from "notistack";
import React, { ChangeEvent, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Button from "../components/UI/Button";
import { ProgressContainer } from "../components/UI/ProgressContainer";
import { handleError, InputState } from "../utils/utils";

export const PagePasswordReset: React.FC = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const emailInputRef = useRef<HTMLInputElement>(null);
  const [email, setEmail] = useState<InputState>({ errorMessage: undefined, value: "" });
  const [emailSent, setEmailSent] = useState<boolean>(false);

  async function onSubmitHandler(event: React.MouseEvent<HTMLButtonElement>) {
    event.preventDefault();
    const enteredEmail = emailInputRef.current!.value;
    const auth = getAuth();
    try {
      setIsLoading(true);
      await sendPasswordResetEmail(auth, enteredEmail)
      setEmailSent(true);
      setIsLoading(false);
      enqueueSnackbar("E-Mail zum Zurücksetzen des Passworts erfolgreich gesendet", {
        variant: "success",
        persist: false,
        anchorOrigin: { vertical: "top", horizontal: "center" },
      });
    } catch (error) {
        handleError("Fehler beim Zurücksetzen des Passworts", error, enqueueSnackbar, setIsLoading);
    }
  }

  function onEmailChange(event: ChangeEvent<HTMLInputElement>) {
    let errorMessage: string | undefined = "";
    const email: string = event.currentTarget.value.trim();
    // eslint-disable-next-line
    const regex = new RegExp(/.+\@.+\..+/)
    if (email.match(regex) == null) {
      errorMessage = "E-Mailadresse ist nicht valide.";
    } else {
      errorMessage = undefined;
    }
    setEmail({ errorMessage: errorMessage, value: email });
  }

  return (
    <ProgressContainer size="max-w-xl" isLoading={isLoading}>
      <form noValidate>
        <TextField className="w-full mb-3"
                   onChange={onEmailChange}
                   inputRef={emailInputRef}
                   helperText={email.errorMessage}
                   id="inputEmail"
                   label="E-Mailadresse"
                   type="email"
                   error={email.errorMessage? true : false}
                   placeholder="E-Mail eingeben..."/>
        <p className="text-gray-500 mb-5 mx-2">
          Es kann einige Minuten dauern, bis Sie eine E-Mail erhalten. Bitte verwenden Sie die
          E-Mailadresse, welche dem Verein bekannt ist und vergessen Sie nicht den Spam-Ordner zu überprüfen.
        </p>
        <Button disabled={email.value.length === 0 || email.errorMessage || emailSent ? true: false || isLoading} type="submit" className="w-full" onClick={onSubmitHandler}>
          Passwort zurücksetzen
        </Button>
        <p className="text-gray-800 mt-6 text-center">
          <Link to="/login" className="text-blue-600 hover:text-blue-700 focus:text-blue-700 transition duration-200 ease-in-out">
            Zurück zum Login
          </Link>
        </p>
      </form>
    </ProgressContainer>
  );
};
